/** Utilities for reliable media-type detection.
 *
 * Browsers often misreport MIME types for professional video formats
 * (.mov, .mkv, .mxf, etc.) as "application/octet-stream". These helpers
 * fall back to file-extension matching so the UI correctly identifies
 * video assets regardless of the stored MIME type.
 */

const VIDEO_EXTENSIONS = new Set([
  'mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v',
  'ts', 'mts', 'm2ts', 'mxf', 'r3d', 'braw', 'prores',
])

/** Check whether an asset represents a video file. */
export function isVideoAsset(asset: { file_type?: string | null; original_filename?: string | null }): boolean {
  if (asset.file_type?.startsWith('video/')) return true
  const ext = asset.original_filename?.split('.').pop()?.toLowerCase()
  return ext ? VIDEO_EXTENSIONS.has(ext) : false
}
